import React from 'react'
import Create from '../crud/create'
import fields from './fields'
import menuItems from './menuItems'
import accountTypeOptions from './account-type-options'

const createFields = fields.slice()
// @ts-ignore
createFields.unshift({
  name: 'Account Type',
  prop: 'account_type',
  type: 'select',
  options: accountTypeOptions
})

const CreateOrder = props => {
  return (
    <Create
// @ts-ignore
      title='Create Order'
      fields={createFields}
      apiPath='admin/orders'
      successRedirectPath={resource => `/ecommerce/orders/${resource.id}/edit`}
      buildMenuItems={menuItems}
    />
  )
}

export default CreateOrder
